import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const FooterWrapper = styled.footer`
  background: ${({ theme }) => theme.colors.bgDark};
  color: ${({ theme }) => theme.colors.text.light.medium};
  margin-top: 60px;
`;

export const FooterContent = styled.div`
  max-width: ${({ theme }) => theme.metrics.contentMaxWidth};
  margin: 0 auto;
  padding: 48px ${({ theme }) => theme.metrics.paddingHorizontal};
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 32px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const FooterColumn = styled.div``;

export const FooterTitle = styled.h4`
  font-family: ${({ theme }) => theme.typography.heading};
  font-size: ${({ theme }) => theme.typography.sizes.lg};
  color: ${({ theme }) => theme.colors.text.light.very};
  margin-bottom: 20px;
`;

export const FooterLink = styled(Link)`
  display: block;
  color: ${({ theme }) => theme.colors.text.light.little};
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  padding: 6px 0;
  transition: color 0.2s;

  &:hover {
    color: ${({ theme }) => theme.colors.secondary.main};
  }
`;

export const BottomBar = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 20px 0;
`;

export const BottomBarInner = styled.div`
  max-width: ${({ theme }) => theme.metrics.contentMaxWidth};
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.metrics.paddingHorizontal};
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`;

export const Copyright = styled.p`
  font-size: ${({ theme }) => theme.typography.sizes.xs};
  color: ${({ theme }) => theme.colors.text.light.little};
`;

export const SocialLinks = styled.div`
  display: flex;
  gap: 16px;
`;

export const SocialLink = styled.a`
  color: ${({ theme }) => theme.colors.text.light.little};
  font-size: 18px;
  transition: color 0.2s;

  &:hover {
    color: ${({ theme }) => theme.colors.secondary.main};
  }
`;

export const BackToTop = styled.button`
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.secondary.main};
  color: ${({ theme }) => theme.colors.primary.dark};
  border: none;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
  z-index: 50;

  &:hover {
    background: ${({ theme }) => theme.colors.secondary.dark};
    transform: translateY(-2px);
  }
`;
